import { getActivityFeedSettingsStore } from '../store/notificationSettingStore';
import { patchActivityFeedSettings } from '../service/patchActivityFeedSettings';
import loadActivityFeed from './loadActivityFeed';
import { toggleActivityFeedSettingPage } from '../actions/toggleActivityFeedSettingPage';
import { getActivityFeedStore } from '../store/store';

export default function saveActivityFeedSettings(isOpx?: boolean) {
    const saveActivityFeedSettingsPromise = patchActivityFeedSettings(
        getActivityFeedSettingsStore(),
        isOpx ?? false
    );

    saveActivityFeedSettingsPromise.then(_ => {
        if (getActivityFeedStore().isActivityFeedOpen) {
            // do not fetch activityfeed while closing the pane.
            loadActivityFeed(isOpx);
        }
    });

    toggleActivityFeedSettingPage(false);
}
